import { SpotMarketConfig } from '@velocity-exchange/sdk';

const SWAP_TO_SOL_FIRST_RECOMMENDATION = (
	<div className="flex flex-col gap-2">
		<div>
			To avoid transaction failures when swapping, please follow below steps:
		</div>
		<div className="flex items-center gap-2">
			<div className="flex size-4 items-center justify-center rounded-full bg-main-bg text-purple-link">
				1
			</div>{' '}
			Swap to SOL
		</div>
		<div className="flex items-center gap-2">
			<div className="flex size-4 items-center justify-center rounded-full bg-main-bg text-purple-link">
				2
			</div>{' '}
			Swap SOL to your desired asset
		</div>
	</div>
);

export const useSwapPairWarning = ({
	fromToken,
	toToken,
}: {
	fromToken: SpotMarketConfig;
	toToken: SpotMarketConfig;
}) => {
	const noSolSwap = fromToken.symbol !== 'SOL' && toToken.symbol !== 'SOL';

	return noSolSwap ? SWAP_TO_SOL_FIRST_RECOMMENDATION : null;
};
